// biome-ignore lint/style/useImportType: legacy import, will be migrated
import * as React from 'react';
import ReactDOM from 'react-dom';

import { useIsClient } from '@crehana/react-hooks';

import SocialNotification from './SocialNotification';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { SocialNotificationPortalProps } from './types';

const SocialNotificationPortal: React.FC<
  React.PropsWithChildren<SocialNotificationPortalProps>
> = props => {
  const isClient = useIsClient();

  if (!isClient) {
    return null;
  }

  return ReactDOM.createPortal(
    <SocialNotification {...props} />,
    document.body,
  );
};

export default SocialNotificationPortal;
